<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import {
  ADDON_GROUP, BILLING_CYCLE as BillingCycle,
  BILLING_CYCLE, dependMeetingPlanTypeList, EventSaasConsumptionOverageCategory,
  EventSaasCoreConsumptionOverageCategory,
  limitLicenseWithBaseZoneTypes,
} from '@/common/constants';
import planCommonMixin from '@/plans/EVENT_SAAS_CORE/mixin';
import addonCustomSelect from '@/plans/mx/addonCustomSelect';
import { planTypes } from "@/common/constants";
import { getPlanTypeByCategory } from '@/common/service/parse';
import { pageConfig } from '@/common/service/page-config';
import { filter, get, orderBy } from 'lodash';
import { plansof } from '@/utils/chain';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import TwoWayControlMixin from '@/plans/EVENT_SAAS/mixins/two-way-control';
import PbxMixin from '@/plans/ZONE_PRO_PLUS/mixin/pbx-mixin';
import { computedPbxBasePlans } from '@/common/service/computers/plans/pbx';

export default {
  mixins: [base, planCommonMixin,addonCustomSelect,TwoWayControlMixin,PbxMixin],
  group() {
    return [ADDON_GROUP.WIN_BACK];
  },
  data(){
    return {
      onlyMixinsFunc: true,
    }
  },
  computed:{
    ...mapGetters(['getCurrentBasePlanInfo']),
    currentProductPlans() {
      let minPriceBillingCycle = BillingCycle.MONTHLY;
      const {
        planCode,
      } = this.pastPlans.find((item) => planTypes[item.semanticType] === this.planType) || {};
      if (planCode === EventSaasConsumptionOverageCategory) {
        minPriceBillingCycle = BILLING_CYCLE.PAY_PER_ATTENDEE;
      }
      return orderBy(
        filter(this.planMapFlat, (p) => p.type === this.planType && p.billing_cycle === minPriceBillingCycle),
        ['capacity'],
        'asc',
      );
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
    planInfo() {
      return this.planMapFlat.filter((item) => item.type === this.planType).filter((item) => item.billing_cycle === this.basePlanBillingCycle);
    },
    basePlanBillingCycle() {
      const {
        planCode,
      } = this.pastPlans.find((item) => planTypes[item.semanticType] === this.planType) || {};
      if (planCode === EventSaasCoreConsumptionOverageCategory) {
        return BILLING_CYCLE.PAY_PER_ATTENDEE;
      }
      let basePlanType = '';
      if (limitLicenseWithBaseZoneTypes.includes(this.planType)) {
        basePlanType = [...new Set(this.getSelectedPlans.map((x) => x.type))].find((x) => dependMeetingPlanTypeList.includes(x)) || planTypes.ZOOM_MEETING;
      } else {
        basePlanType = getPlanTypeByCategory(pageConfig.plan || 'pro');
      }
      const hasMonthlyCapacity = plansof(this.planMapFlat).code(planCode).monthly().has();
      const hasAnnualCapacity = plansof(this.planMapFlat).code(planCode).annual().has();
      if (hasMonthlyCapacity && hasAnnualCapacity) {
        return this.form.billingCycle || this.getSelectedPlans.find((item) => item.type === basePlanType)?.billing_cycle || BillingCycle.MONTHLY;
      } else if (hasMonthlyCapacity) {
        return BillingCycle.MONTHLY;
      } else if(hasAnnualCapacity) {
        return BillingCycle.ANNUAL;
      } else {
        return BillingCycle.MONTHLY;
      }
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan', 'removePlan','setPbxBillingCycle']),
    ...mapActions(['removePlanByKey']),
    async addOn(evt) {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      const addPlanFromEnterKey = get(evt?.target, 'tagName', '') == 'BUTTON';
      if (addPlanFromEnterKey) {
        document.addPlanFromEnterKey = true;
      }
      if (this.formPlan.billing_cycle === BillingCycle.ANNUAL && this.formPlan.capacity > 100 && this.getCurrentBasePlanInfo?.plans?.find(item => item.billing_cycle === BILLING_CYCLE.MONTHLY)) {
        await this.switchBaseBillingCycleAndBanner(BillingCycle.ANNUAL, true);
        if ([planTypes.ZONE_PRO_PLUS, planTypes.ZONE_EDU_PLUS].includes(this.getCurrentBasePlanInfo.planType)) {
          this.switchPbxAddonAndBasePbx(BillingCycle.ANNUAL);
        }
      }
      this.updateSelectPlan({
        ...this.formPlan,
        cartInfo: {
          selected_number: this.form.selectedNumber || 1,
        },
      });
      this.$emit('add', this.$options?.key);
      this.$tracking.addOnBuyInteraction(`${this.trackingBasePlanName} add-ons`, `add-ons - ${this.title?.toLowerCase()} - ${this.trackingAddAction}`);
      this.$nextTick(this.focusToConfig);
    },
    async undoChange() {
      this.removePlanByKey(this.planType);
      await this.switchBaseBillingCycleAndBanner(BillingCycle.MONTHLY, false);
      if ([planTypes.ZONE_PRO_PLUS, planTypes.ZONE_EDU_PLUS].includes(this.getCurrentBasePlanInfo.planType)) {
        //computed getSelectedPlans generates cache and does not generate dependencies
        const pbxBasePlan = computedPbxBasePlans(this.$store.getters.getSelectedPlans)[0];
        this.setPbxBasePlanCode(pbxBasePlan.plan_code);
      }
      this.clearMessageBoxInstances()
    }
  },

};
</script>
